import { render, staticRenderFns } from "./ContabilitaFatturazioneList.vue?vue&type=template&id=4915b658"
import script from "./ContabilitaFatturazioneList.vue?vue&type=script&lang=js"
export * from "./ContabilitaFatturazioneList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports